export const SEARCH_ITEM_NAME = "SEARCH_ITEM_NAME"
export const STORE_ITEM_NAME_RESULT = "STORE_ITEM_NAME_RESULT"
